import { useParams } from "react-router-dom";
import { getTransactions } from "../services/utils";
import { useEffect, useState } from "react";
import BlockContent from "../components/BlockContent";
import Navbar from "../components/Navbar";

const Tx = () => {
    let { txhash } = useParams();
    const [block, setBlock] = useState({});
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (txhash) {
                    const txData = await getTransactions(txhash);
                    setBlock(txData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    return (
        <>
            <div className="h-screen">
                <Navbar />
                <div className="flex flex-col mx-auto mt-20 w-[90%] gap-10">
                    <div className="w-full">
                        <h1 className="font-semibold text-2xl">Transaction Details</h1>
                    </div>
                    <div className="bg-blue-300">
                        <BlockContent blockInfo={block} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Tx;
